/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Export_Markdown_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to export Markdown" |
*
* @param {Editor_Export_Markdown_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_export_markdown_failed = /** @type {((inputs?: Editor_Export_Markdown_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Export_Markdown_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Exportieren als Markdown")
	return /** @type {LocalizedString} */ ("Failed to export Markdown")
});